import EditIcon from '@/shared-components/icons/components/new-icons/EditIcon';

import './styles/ShippingCard.css';

export default function ShippingCard({ data, isSelected, selectShipping, setAddressToEdit }) {
  function handleContainerClick() {
    if (selectShipping) {
      selectShipping();
    }
  }

  function handleKeyDown(event) {
    if (!selectShipping) {
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      selectShipping();
    }
  }

  function handleSelectorClick(event) {
    event.stopPropagation();
    handleContainerClick();
  }

  function handleEditClick(event) {
    event.stopPropagation();
    if (setAddressToEdit) {
      setAddressToEdit(data);
    }
  }

  return (
    <>
      <div
        className={`purchase-shipping-card__container element-non-selectable${isSelected ? ' selected' : ''}`}
        role="button"
        tabIndex={0}
        onClick={handleContainerClick}
        onKeyDown={handleKeyDown}
      >
        <div className={`purchase-shipping-card__selector ${isSelected ? 'active' : ''}`} onClick={handleSelectorClick} />

        <div className="purchase-shipping-card__info">
          <span className="purchase-shipping-card__big-text">
            {data.address_name} {data.address_surname}
          </span>

          <span className="purchase-shipping-card__text font-size-medium">
            {data.address_street || data.address_address}
          </span>

          <span className="purchase-shipping-card__text font-size-medium">
            {data.address_city}{", "}
            {data.address_region}{", "}
            {data.address_country}{", "}
            {data.address_zip_code}
          </span>

          <span className="purchase-shipping-card__text font-size-medium">
            {data.address_phone.address_phone_prefix} {data.address_phone.address_phone_number}
          </span>
        </div>

        <span className="purchase-shipping-card__edit-button element-non-selectable" onClick={handleEditClick}>
          <EditIcon className="purchase-shipping-card__edit-icon" />
        </span>
      </div>
    </>
  );
}
